import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Radio from '@atoms/Radio/Radio';
import Text from '@atoms/Text/Text';

// Shared styles for focus, hover, and selected states
const selectedStyles = css`
  // increase border and reduce margin to avoid flickering when focus or hover
  border-color: ${variables.colors.highlight};
  box-shadow: inset 0 0 0 ${rem(1)} ${variables.colors.highlight};
`;

export const StyledTimeSlotItem = styled.button<{ 'data-selected': boolean; disabled?: boolean }>`
  background-color: ${variables.colors.white};
  border: ${rem(1)} solid ${variables.colors.mediumGray};
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: ${rem(20)};
  border-radius: ${rem(4)};

  ${(props) =>
    !props.disabled &&
    css`
      &:hover {
        ${selectedStyles}
      }
    `}

  ${(props) =>
    props['data-selected'] &&
    css`
      ${selectedStyles}
    `};

  ${(props) =>
    props.disabled &&
    css`
      color: ${variables.colors.darkerGray};
      border-color: ${variables.colors.mediumGray};
      cursor: default;
    `};
`;

export const StyledSlotTimeText = styled(Text)<{ $disabled: boolean }>`
  ${(props) =>
    props.$disabled &&
    css`
      text-decoration: line-through;
    `};
`;

export const StyledSlotTextWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  gap: ${rem(12)};
`;

export const StyledSlotTextInformationInnerWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSlotTextInformation = styled.div`
  display: flex;
  text-align: left;
`;

export const StyledRadio = styled(Radio)`
  margin-right: ${rem(8)};
`;
